import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Payment\GetPaymentListController::__invoke
* @see app/Http/Controllers/Payment/GetPaymentListController.php
* @route '/api/payment-dashboard'
*/
const GetPaymentListController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetPaymentListController.url(options),
    method: 'post',
})

GetPaymentListController.definition = {
    methods: ["post"],
    url: '/api/payment-dashboard',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Payment\GetPaymentListController::__invoke
* @see app/Http/Controllers/Payment/GetPaymentListController.php
* @route '/api/payment-dashboard'
*/
GetPaymentListController.url = (options?: RouteQueryOptions) => {
    return GetPaymentListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Payment\GetPaymentListController::__invoke
* @see app/Http/Controllers/Payment/GetPaymentListController.php
* @route '/api/payment-dashboard'
*/
GetPaymentListController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetPaymentListController.url(options),
    method: 'post',
})

export default GetPaymentListController